import { useEffect, useRef } from "react";

export default function LandingPageNew() {

  const iframeRef = useRef(null);


  return (

    <iframe
      ref={iframeRef}
      src="/LandingPage/index.html"
      width="100%"
      height="1000px"
      style={{
        border: "none",
        display: "block"
      }}
      title="HTML Page"
    />

  );
}